export const generateId = () => {
  return crypto.randomUUID();
};
